/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
var LOAD = 'baltimorebrew.com/navSections/LOAD';
var LOAD_SUCCESS = 'baltimorebrew.com/navSections/LOAD_SUCCESS';
var LOAD_FAIL = 'baltimorebrew.com/navSections/LOAD_FAIL';

var initialState = {
	loaded: false,
	data: []
};

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	switch (action.type) {
		case LOAD:
			{
				return _extends({}, state, {
					loading: true
				});
			}
		case LOAD_SUCCESS:
			{
				return _extends({}, state, {
					loading: false,
					loaded: true,
					data: action.result,
					error: null
				});
			}
		case LOAD_FAIL:
			{
				return _extends({}, state, {
					loading: false,
					loaded: false,
					data: null,
					error: action.error
				});
			}
		default:
			{
				return state;
			}
	}
}

function isLoaded(globalState) {
	return globalState.navSections && globalState.navSections.loaded;
}

function load() {
	return {
		types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
		promise: function promise(client) {
			return client.get('/wp/v2/categories?parent=24&per_page=100&hide_empty=true');
		}
	};
}
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/navSections.js
 ** module id = 264
 ** module chunks = 0
 **/